export default "__VITE_ASSET__7mjaH5kY__"